import React, { memo } from 'react';

const MovieRow = memo(({movie, onClick}) => (
    <div onClick={onClick}
         key={movie.id}
         className="flex items-start gap-3 bg-white pb-3"
    >
        <img
            src={movie.poster}
            alt={movie.title}
            className="w-20 h-28 object-cover rounded-lg"
        />
        <div className="flex flex-col justify-between">
            <h5 className="text-sm font-bold text-gray-900 mb-1">
                {movie.title}
            </h5>
            <p className="text-xs text-gray-600 line-clamp-3">
                {movie.description || "Pas de description disponible."}
            </p>
        </div>
    </div>
));

MovieRow.displayName = 'MovieRow';

export default MovieRow;